module.exports = __webpack_public_path__ + "img/step2.f5a0886e.png";